export const INITIAL_POSITION = {
  top: 68,
  right: 16,
  bottom: 16,
};

export const DIALOG_WIDTH = {
  SLIM: 375,
  EXTENDED: 1200,
};

export const TEXT_EDITOR_WIDTH = DIALOG_WIDTH.EXTENDED - DIALOG_WIDTH.SLIM;

export enum ActiveView {
	CHAT = 'chat',
	HISTORY = 'history',
	UNIT_ENTRY = 'unitEntry',
	FREE_DRAFT_ENTRY = 'freeDraftEntry',
	TEMPLATE_PROMPT_FORM = 'templatePromptForm',
	PODCAST_LOADING = 'podcastLoading',
}

export const DEFAULT_HEADLINE_HEIGHT = 50;

// Debounce for auto-saving an artifact title while the user is typing.
export const TITLE_SAVE_DEBOUNCE_MS = 500;

export const ACCEPTED_IMAGE_TYPES: string[] = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
export const ACCEPTED_IMAGE_TYPES_STRING = ACCEPTED_IMAGE_TYPES.join(',');

export const TOOL_NAME_GENERATE_IMAGE = 'generate_image';
export const TOOL_NAME_GENERATE_PODCAST = 'generate_podcast';

// WOR-930: exact copy of the API's PODCAST_GENERATION_STARTED_MESSAGE
// (api server/constants/assistant/stream.ts). This internal placeholder is
// never shown — the chat filters this exact string out of the message text and
// shows the podcast card instead. Must stay identical to the backend constant.
export const PODCAST_GENERATION_STARTED_MESSAGE = 'podcast generation started';

export const MAX_ATTACHMENTS_PER_REQUEST = 3;
export const MAX_ATTACHMENTS_PER_CONVERSATION = 10;
export const MAX_UPLOADS_PER_DAY = 20;
